module.exports = __webpack_public_path__ + "static/osiris_01-7171ea93a6a0b8f04faee3e8b3fa4231.jpg";